<template>
  <div class="app-container">
    <div class="chip-selector">
  <span class="chip" @click="filterGamesByType('All')" :class="{ selected: selectedtype === '' }">All</span>
  <!-- Example static game types -->
  <span class="chip" @click="filterGamesByType('quiz')" :class="{ selected: selectedtype === 'quiz' }">Quiz</span>
  <span class="chip" @click="filterGamesByType('scenario')" :class="{ selected: selectedtype === 'scenario' }">Scenario</span>
  <span class="chip" @click="filterGamesByType('fill-in-the-blank')" :class="{ selected: selectedtype === 'fill-in-the-blank' }">Fill in the blank</span>
  <span class="chip" @click="filterGamesByType('flashcard')" :class="{ selected: selectedtype === 'flashcard' }">Flashcards</span>
</div>

    <!-- Games Display -->
    <div class="games-display">
      <div
  class="game-card"
  v-for="game in filteredGames"
  :key="game.id"
  @click="startGame(game)"
  :class="{ 'locked': game.locked }"
      >
        <div class="card-header">
          <i :class="`fas ${gameTypeIcon(game.type)}`"></i>
          <span class="game-topic-name">{{ game.topicName }}</span>
          <i 
            class="far fa-heart favorite-icon" 
            :class="{ 'fas': game.isFavorite }" 
            @click.stop="toggleFavorite(game)"
          ></i>
        </div>
        <div class="game-card-image">
  <img :src="game.imageUrl" alt="Game Image">
  <div v-if="game.locked" class="lock-overlay">
    <i class="fas fa-lock"></i>
  </div>
</div>
        <div class="game-card-body">
          <h3>{{ game.title }}</h3>
          <p>{{ game.description }}</p>
          <div class="game-difficulty">
            <i class="fas fa-star" v-for="n in getDifficultyStars(game.difficulty)" :key="n"></i>Level
          </div>
        </div>
      </div>
    </div>
  </div><br><br><br><br><br><br>
</template>

<script>
import { useRouter } from 'vue-router';
import { ref, computed } from 'vue';

export default {
  setup() {
    const topics = ref([
        { id: 1, name: 'Risk', icon: 'fa-calculator' },
        { id: 2, name: 'Insurance', icon: 'fa-flask' },
        { id: 3, name: 'Savings', icon: 'fa-landmark' },
        { id: 1, name: 'KYC', icon: 'fa-calculator' },
        { id: 2, name: 'Yields', icon: 'fa-flask' },
        { id: 3, name: 'Planning', icon: 'fa-landmark' },
        { id: 1, name: 'Assets', icon: 'fa-calculator' },
        { id: 2, name: 'Wealth Management', icon: 'fa-flask' },
        { id: 3, name: 'Strategies', icon: 'fa-landmark' },
        { id: 1, name: 'Stocks', icon: 'fa-calculator' },
        { id: 2, name: 'GICs', icon: 'fa-flask' },
        { id: 3, name: 'Bank Accounts', icon: 'fa-landmark' },
        { id: 1, name: 'Fraud', icon: 'fa-calculator' },
        { id: 2, name: 'Options', icon: 'fa-flask' },
        { id: 3, name: 'Bonds', icon: 'fa-landmark' },
        // Add more topics as needed
        ]);
      const games = ref([
        {
          id: 1,
          topicName: 'Banking',
          type: 'quiz',
          title: "Intro to Financial Literacy",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/menu',
          locked: false,

        },
        {
          id: 1,
          topicName: 'Bonds',
          type: 'quiz',
          title: "Bonds - the new stocks",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/menu',
          locked: false,

        },
    
        {
          id: 1,
          topicName: 'Stocks',
          type: 'scenario',
          title: "Investing 101",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/menu',
          locked: false,

        },
        {
          id: 1,
          topicName: 'KYC',
          type: 'fill-in-the-blank',
          title: "Credit Cards",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "expert",
          isFavorite: false,
          route: '/games/menu',
          locked: false,

        },
        {
          id: 1,
          topicName: '',
          type: 'quiz',
          title: "Taxes 101",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/menu',
          locked: false,

        },
        {
          id: 1,
          topicName: 'Risk',
          type: 'quiz',
          title: "Income Taxes",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/menu',
          locked: false,

        },
        {
          id: 1,
          topicName: 'Risk',
          type: 'quiz',
          title: "Sales Tax",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/menu',
          locked: false,

        },
        {
          id: 1,
          topicName: 'Risk',
          type: 'quiz',
          title: "Estate Planning",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "beginner",
          isFavorite: false,
          route: '/games/menu',
          locked: true,

        },
        {
          id: 1,
          topicName: 'Risk',
          type: 'quiz',
          title: "Value at Risk (VAR)",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "expert",
          isFavorite: false,
          route: '/games/menu',
          locked: true,

        },
        {
          id: 1,
          topicName: 'Risk',
          type: 'quiz',
          title: "Expected Shortfall",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "expert",
          isFavorite: false,
          route: '/games/menu',
          locked: true,

        },
        {
          id: 1,
          topicName: 'Risk',
          type: 'quiz',
          title: "Futures Trading 101",
          description: "Solve challenging puzzles to master math skills.",
          imageUrl: "https://assets.codepen.io/11151897/Catsagain.png",
          difficulty: "expert",
          isFavorite: false,
          route: '/games/menu',
          locked: true,

        },
        // Add more games as needed
        ]);
   
        const slider = ref(null);
        const selectedtype = ref('');

        const filteredGames = computed(() => {
      if (!selectedtype.value || selectedtype.value === 'All') {
        return games.value;
      } else {
        return games.value.filter(game => game.type === selectedtype.value);
      }
    });

    const gameTypeIcon = (type) => {
      switch (type) {
        case 'quiz': return 'fa-question-circle';
        case 'scenario': return 'fa-users';
        case 'fill-in-the-blank': return 'fa-pencil-alt';
        case 'flashcard': return 'fa-images';
        default: return 'fa-gamepad';
      }
    };

    const toggleFavorite = (game) => {
      game.isFavorite = !game.isFavorite;
    };

    const filterGamesByType = (type) => {
      selectedtype.value = type === 'All' ? '' : type; // Corrected to use selectedType
    };

    const router = useRouter();

    const startGame = (game) => {
  if (!game.locked && game.route) {
    router.push(game.route);
  }
};
    const getDifficultyStars = (difficulty) => {
      switch (difficulty) {
        case 'beginner':
          return 1;
        case 'intermediate':
          return 2;
        case 'advanced':
          return 3;
        case 'expert':
          return 4;
        default:
          return 0; // No stars if difficulty level is undefined
      }
    };
    const scrollLeft = () => {
      if(slider.value) {
        slider.value.scrollLeft -= 200;
      }
    };

    const scrollRight = () => {
      if(slider.value) {
        slider.value.scrollLeft += 200;
      }
    };


    return {
      topics,
      games,
      filteredGames,
      filterGamesByType,
      gameTypeIcon,
      toggleFavorite,
      scrollLeft,
      scrollRight,
      startGame,
      getDifficultyStars,

    };
  }
};
</script>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}


.locked {
  filter: grayscale(100%); /* Grey out locked games */
  cursor: not-allowed; /* Change cursor to indicate it's not interactable */
  pointer-events: none; /* Prevent clicking on the card */
}
.games-display {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  width: 100%;
  padding: 20px;
}

.game-card {
  position: relative; 
  width: 250px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
}

.game-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #4A148C;
  color: white;
}

.game-card-image img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}
.lock-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5); /* semi-transparent overlay */
  color: white; /* Lock icon color */
  font-size: 24px; /* Lock icon size */
}
.game-card-body {
  padding: 10px;
  text-align: left;
}

.game-difficulty {
  display: flex;
  justify-content: flex-end; /* Aligns difficulty stars to the right */
  padding: 5px 10px;
  
}
.chip-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  padding: 10px 0;
  
}

.chip {
  background-color: #f1f1f1;
  padding: 8px 16px;
  border-radius: 25px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.chip.selected {
  background-color: #4A148C;
  color: white;
}
.favorite-icon {
  cursor: pointer;
}

/* Responsive Design */
@media (max-width: 768px) {
  .game-card {
    width: calc(50% - 20px); /* Adjust for smaller screens */
  }
}

@media (max-width: 480px) {
  .topics-slider-container {
    width: 100%;
  }

  .game-card {
    width: 100%; /* Full width on very small screens */
    margin: 10px 0;
  }
}
</style>